import GOT from './GOT';
export default class GOTUtil
{
	//static flatMainMenuToMenuItem = {};

	static getNormalRelationItem(dataType)
	{
		/**
		 *新版本中 DataTypeRelatioItem Normal没有了
		 * 
		 **/
		var items = dataType.DataTypeRelation.DataTypeRelationItems;
		if(!items || items.length == 0)
		{
			return {Properties:{Field:dataType.DataTypeRelation.Properties.Field}};
		}
		for(var i = 0;i<items.length;i++)
		{
			var item = items[i];
			if(item.type == "Normal")
				return item;
		}
		return null;
	}

	static getFixedRelationItem(dataType)
	{
		var result = [];
		var items = dataType.DataTypeRelation.DataTypeRelationItems;
		for(var i = 0;i<items.length;i++)
		{
			var item = items[i];
			if(item.type == "Fixed")
				result.push(item);
		}
		return result;	
	}

	static getShortCut(table)
	{
		if(table == null)
			return null;
		var results = null;
		var shortcutPro = table.Properties.ShortCutField;
		if(shortcutPro && shortcutPro.hasOwnProperty("innerid"))
		{
			var innerid = shortcutPro.innerid;
			for(var i in table.TableFields)
			{
				var tableField = table.TableFields[i];
				if(tableField.id == innerid)
					return tableField;
			}
		}
		
		return null;
	}
	
	static isTableFieldShortCut(tableField)
	{
		var extendsPro = tableField.Properties.Field;
		if(extendsPro.hasOwnProperty("refentityid"))
		{
			var entityid = extendsPro.refentityid;
			var innerid = extendsPro.refinnerid;
			var table = GOT.getTable(entityid);
			var shortcutPro = table.Properties.ShortCutField;
			if(shortcutPro && shortcutPro.innerid == innerid)
			{
				return true;
			}
		}
		
		return false;
	}

	static isFormItemShortCut(formItem)
	{
		var extendsPro = formItem.Properties.Extends;
		if(extendsPro.hasOwnProperty("refentityid"))
		{
			var entityid = extendsPro.refentityid;
			var innerid = extendsPro.refinnerid;
			var table = GOT.getTable(entityid);
			var shortcutPro = table.Properties.ShortCutField;
			if(shortcutPro && shortcutPro.innerid == innerid)
			{
				return true;
			}
		}
		
		return false;
	}
	
	static getDataTypePropertyValueFromFormItem(formItem, propertyName)
	{
		//本方法针对FormItem_Editor 但不支持Enum类型
		var pFormItem = formItem.Properties.Extends;
		if(pFormItem==null)
			return null;
		
		if(!pFormItem.hasOwnProperty("refentityid"))
			return null;
		
		if(pFormItem.hasOwnProperty("refinnerid"))
		{
			var table = GOT.getTable(pFormItem.refentityid);
			if(table!=null)
			{
				var tableField = GOT.getTableField(table,pFormItem.refinnerid);
				var pTableField = tableField.Properties.Extends;
				if(!pTableField.hasOwnProperty("refentityid"))
					return null;
				
				var dataType = GOT.getDataType(pTableField.refentityid);
			}
			else
			{
				return null;
			}
		}
		else
		{
			dataType = GOT.getDataType(pFormItem.refentityid);
		}
		
		if(dataType.type=="Component")
		{
			var itemName = pFormItem.V.split(".")[1];
			var arrayItem = GOT.getDataTypeArrayItem(itemName);
			let refentityId = arrayItem.Properties.RefDataType.refentityid;
			dataType = GOT.getDataType(refentityId);
		}
		var value = dataType.Properties[propertyName].Value;
		while(value=="")
		{
			let refentityId = dataType.Properties["Extends"].refentityid;
			dataType = GOT.getDataType(refentityId);
			value = dataType.Properties[propertyName].Value;
		}
		
		if(value=="")
			return null;
		else
			return value;
	}
	
	// static getItemEntity(item)
	// {
	// 	if(item.hasOwnProperty("version"))
	// 		return item;
	// 	else
	// 		return getItemEntity(item.parent());
	// }
	
	static isFindQueryField(propertyName)
	{
		if(propertyName == "Label" || propertyName == "NumOfDecimal" || propertyName == "StringSize")
			return true;
		return false;
	}	
	
	static getPropertyValueStepByStep(item, entity, propertyName, validateString, validateEquals, findFormDataSourceField)
	{
		var value;
		
		if(item.qname=="FormItem")
		{
			value = item.Properties[propertyName].Value;
			//item.Properties.Property.(Name==propertyName).Value;
			if(validateEquals)
			{
				if(value==validateString)	return value;
			}
			else
			{
				if(value!=validateString)	return value;
			}
			
			var pFormItem_Extends;
			if(item.type=="FieldGroup")
			{
				pFormItem_Extends = item.Properties["Component"];
				if(!pFormItem_Extends.hasOwnProperty("refentityid"))
				{
					//pFormItem_Extends = getProperty(item,"FieldGroup");
					return value;
				}
			}
			else
			{
				pFormItem_Extends = item.Properties["Extends"];
			}
			
			if(pFormItem_Extends == null)
				throw new Error("FromItem上找不到Extends");
			
			
			var isQueryField = false;
			if(!pFormItem_Extends.hasOwnProperty("refentityid") && isFindQueryField(propertyName))
			{
				pFormItem_Extends = item.Properties["QueryField"];
				if(pFormItem_Extends == null || !pFormItem_Extends.hasOwnProperty("refentityid"))
					return value;
				isQueryField = true;
			}
			if(pFormItem_Extends.hasOwnProperty("refinnerid"))
			{
				if(pFormItem_Extends.Value == "")
					return "";
				if(findFormDataSourceField)
				{
					if(isQueryField == false)
					{
						var pFormItem_DataSource = item.Properties["DataSource"];
					}
					else
					{
						pFormItem_DataSource = item.Properties["QuerySource"];
					}
					
					if(pFormItem_DataSource == null ||　!pFormItem_DataSource.hasOwnProperty("innerid"))
						return value;
					var innerid = pFormItem_DataSource.innerid;
					//TODO form
					var formDataSource = GOT.getFormDataSource(window.formXML,innerid);
					var formDataSourceFieldName = pFormItem_Extends.Value;
					item = GOT.getFormDataSourceField(formDataSource,formDataSourceFieldName);
					/*item = XML(getItemEntity(item).FormDataSources.FormDataSource.(@id==pFormItem_DataSource.@innerid)[0])
						.FormDataSourceFields.FormDataSourceField.(@name==pFormItem_Extends.Value)[0];*/
					
				}
				else
				{
					let refentityId = pFormItem_Extends.refentityid;
					let refinnerId = pFormItem_Extends.refinnerid;
					var table = GOT.getTable(refentityId);
					item = GOT.getTableField(table,refinnerId);
					//item = GOT.getTable(pFormItem_Extends.@refentityid).TableFields.TableField.(@id==pFormItem_Extends.@refinnerid)[0];
				}
				
			}
			else if(pFormItem_Extends.hasOwnProperty("refentityid"))
			{
				item = GOT.getDataType(pFormItem_Extends.refentityid);
				if(item==null)
					item = GOT.getEnum(pFormItem_Extends.refentityid);
			}
		}

		
		if(item.qname=="FormDataSourceField")
		{
			value = item.Properties.hasOwnProperty(propertyName)?item.Properties[propertyName].Value:"";
			if(validateEquals)
			{
				if(value==validateString)	return value;
			}
			else
			{
				if(value!=validateString)	return value;
			}
			
			var pFormDataSourceField_Field = item.Properties["Field"];
			let _refentityId = pFormDataSourceField_Field.refentityid;
			let _refinnerId = pFormDataSourceField_Field.refinnerid;
			let _table = GOT.getTable(_refentityId);
			item = GOT.getTableField(_table,_refinnerId);
			//item = GOT.getTable(pFormDataSourceField_Field.@refentityid).TableFields.TableField.(@id==pFormDataSourceField_Field.@refinnerid)[0];
		}
		
		
		
		
		if(item.qname=="TableField")
		{
			value = item.Properties.hasOwnProperty(propertyName)?item.Properties[propertyName].V:"";
			if(propertyName=="Visible")	//即使碰到Component，也不展开，直接返回
				return value;
			
			if(propertyName == "AllowEdit" || propertyName == "NotNull")
			{
				return value;
			}
			
			if(item.type=="Component")
			{
				if(pFormItem_Extends && pFormItem_Extends.Value.indexOf(".")!=-1)
				{
					pTableField_Extends = item.Properties["Extends"];
					let refentityId = pTableField_Extends.refentityid;
					let componentDataType = GOT.getDataType(refentityId);
					let arrayItemName = pFormItem_Extends.Value.split(".")[1];
					let dataTypeArrayItem = GOT.getDataTypeArrayItem(componentDataType,arrayItemName);
					refentityId = dataTypeArrayItem.Properties["RefDataType"].refentityid;
					item = GOT.getDataType(refentityId);
					/*item = GOT.getDataType(
					GOT.getDataType().DataTypeArray.DataTypeArrayItem
						.(@name==String(pFormItem_Extends.Value).split(".")[1])
						.Properties.Property.(Name=="RefDataType").@refentityid);	*/
				}
				else if(pFormDataSourceField_Field && pFormDataSourceField_Field.Value.indexOf(".")!=-1)
				{
					pTableField_Extends = item.Properties["Extends"];
					var t = GOT.getDataType(pTableField_Extends.refentityid);
					let arrayItemName = pFormDataSourceField_Field.Value.split(".")[1];
					let arrayItem = GOT.getDataTypeArrayItem(t,arrayItemName);
					let refentityId = arrayItem.Properties["RefDataType"].refentityid;
					item = GOT.getDataType(refentityId);
					/*item = GOT.getDataType(
						t.DataTypeArray.DataTypeArrayItem.(@name==String(pFormDataSourceField_Field.Value).split(".")[1])
						.Properties.Property.(Name=="RefDataType").@refentityid);*/
				}
				else
				{
					if(validateEquals)
					{
						if(value==validateString)	return value;
					}
					else
					{
						if(value!=validateString)	return value;
					}
					pTableField_Extends = item.Properties["Extends"];
					if(!pTableField_Extends.hasOwnProperty("refentityid"))
						return value;
					item = GOT.getDataType(pTableField_Extends.refentityid);						
				}
			}
			else
			{
				if(validateEquals)
				{
					if(value==validateString)	return value;
				}
				else
				{
					if(value!=validateString)	return value;
				}
				var pTableField_Extends = item.Properties["Extends"];
				if(!pTableField_Extends.hasOwnProperty("refentityid"))
					return value;
				item = GOT.getDataType(pTableField_Extends.refentityid);
				if(item==null)
					item = GOT.getEnum(pTableField_Extends.refentityid);
			}
		}
		
		while(item.qname=="DataType")
		{
			var tmp = item.Properties[propertyName];
			if(tmp == null)
				return value;
			value = tmp.V;
			if(validateEquals)
			{
				if(value==validateString)	return value;
			}
			else
			{
				if(value!=validateString)	return value;
			}
			
			var pDataType_Extends = item.Properties["Extends"];
			if(pDataType_Extends==null)
				return value;
			if(!pDataType_Extends.hasOwnProperty("refentityid"))
				return value;
			item = GOT.getDataType(pDataType_Extends.refentityid);
			if(item==null)
				item = GOT.getEnum(pDataType_Extends.refentityid);
			
		}
	
		if(item.qname=="Enum")
		{
			tmp = item.Properties[propertyName];
			if(tmp==null)
				return value;
			value = tmp.V;
			if(validateEquals)
			{
				if(value==validateString)	return value;
			}
			else
			{
				if(value!=validateString)	return value;
			}
		}
			
		return value;

	}
	
	static hasProperty(reportField,property)
	{
		if(reportField.Properties.hasOwnProperty(property))
			return true;
		else
			return false;
	}
	
	static getReprotFinalValue(item,property)
	{
	 	var nodeName = item.qname;
		if(nodeName == "ReportField")
		{
			if(property == "Extends" || property == "Source")
				return item.Properties[property].V;
			
			var hasProperty = GOTUtil.hasProperty(item,property);
			if(hasProperty)
			{
				var value = item.Properties[property].V;
				if(value != "")
					return value;
			}
			
			var extendsPro = item.Properties["Extends"];
			if(extendsPro.hasOwnProperty("refentityid"))
			{
				var refId = extendsPro.refentityid;
				if(refId.substr(0,2) == "20")
					var entity = GOT.getDataType(refId);
				else 
					entity = GOT.getEnum(refId);
				return GOTUtil.getFinalValue(entity,entity,property);
			}
			
			if(property == "Label")
				return item.name;
			
			//如果是ReportField 并且该属性在这个ReportField上没有并且它又不继承任何DataType
			//或者这个属性在这个ReportField上有但是值是空
			
			if("Regular" == property)
			{
				return "";
			}
			else if("NotNull" == property)
			{
				return "false";
			}
			else if("AllowEdit" == property)
			{
				return "true";
			}
			else if("AllowEditOnCreate"==property)
			{
				return "true";
			}
			else if("Default"==property)
			{
				return "";
			}
			else if("SkipTab"==property)
			{
				return "false";
			}
			else if("DisplayHeight"==property)
			{
				return "1";
			}
			else if("Seperator"==property)
			{
				return "-";
			}
			else if("NumOfYear"==property)
			{
				return "4";
			}
			else if("NumOfMonth"==property)
			{
				return "2";
			}
			else if("NumOfDay"==property)
			{
				return "2";
			}
			else if("Show1970"==property)
			{
				return "true";
			}
			else if("ShowZero"==property)
			{
				return "true";
			}
			else if("ThousandSeperator"==property)
			{
				return ",";
			}
			else if("AllowNegative"==property)
			{
				return "true";
			}
			else if("ShowDecimals"==property)
			{
				return "true";
			}
			else if("RoundOff"==property)
			{
				return "HalfUp";
			}
			else if("Trim"==property)
			{
				return "LeftRight";
			}
			else if("ChangeCase"==property)
			{
				return "None";
			}
			else if("ShowHour"==property)
			{
				return "true";
			}
			else if("ShowMinute"==property)
			{
				return "true";
			}
			else if("ShowSecond"==property)
			{
				return "true";
			}
			
			return "";		
			
		}
		
		if(nodeName == "ReportQuery")
		{
			return item.Properties[property].V;
		}
		
		if(nodeName == "Report")
		{
			var label = item.Properties[property].V;
			if(label == "")
				return item.name;
			return label;
		}
		
		if(nodeName == "Query" && property == "Title")
		{
			value = item.Properties[property].V;
			if(value == "")	
			{
				var queryTable = item.QueryTable;
				if(queryTable == undefined || queryTable == null)
					return item.name;
				extendsPro = item.Properties["Table"];
				if(extendsPro.hasOwnProperty("refentityid"))
					var table = GOT.getTable(extendsPro.refentityid);
				if(table != null)
				{
					value = GOTUtil.getFinalValue(table,table,"Label");
					if(value == "")
						value = item.name;
				}
			}
			return value;
		}
		
		return null;
			
	}
	
	static getFilterFieldFromFormItem(item)
	{
		var result = null;
		if(item.type == "StringEditor")
		{
			var dataSource = item.Properties["DataSource"].V;
			if(dataSource != "")
			{
				var extendsPro = item.Properties["Extends"];
				if(extendsPro.hasOwnProperty("refentityid") && extendsPro.hasOwnProperty("refinnerid"))
				{
					var entityid = extendsPro.refentityid;
					var innerid = extendsPro.refinnerid;
					var tableField = GOT.getTableField(entityid,innerid);
					if(tableField != null)
					{
						var filterField = tableField.Properties["FilterField"].V;
						if(filterField!="")
							return filterField;
					}
				}
			}
		}
		
		return result;
	}
	
	static getFinalValue(item, entity, property)
	{
		var value;
		var p;
		var nodeName = item.qname;
		
		if(nodeName=="FormItem")
		{
			
			if(property=="X" 
				|| property=="Y"
				|| property=="Width"
				|| property=="Height"
				|| property=="HideInvisible"
				|| property=="Layout"
				|| property=="Icon"
				|| property=="DisabledIcon"
				|| property=="ShortCut"
				|| property=="DisplayMode"
				|| property=="SaveRecord"
				|| property=="MultiSelect"
				|| property=="DisplayHeight"
				|| property=="ShowLabel"
				|| property=="LabelPosition"
				|| property=="LabelAlignment"
				|| property=="SearchMode"
				|| property=="ReturnLookup"
				|| property=="Source"
				|| property=="DataSource"
				|| property=="DataMethod"
				|| property=="Extends"
				|| property=="FieldGroup"
				|| property=="Component"
				|| property=="MenuItem"
				|| property=="ShowHeader"
				|| property=="SkipTab"
				|| property=="LabelLength"
				|| property=="HeaderAlign"
				|| property=="Rows"
				|| property=="URL"
				|| property=="Suffix"
				|| property=="Popup"
				|| property=="LayoutMode"
				|| property=="ControlType"
				|| property=="ClassName"
				|| property=="FailureImage"
				|| property=="QueryType"
				|| property=="ButtonType"
				|| property=="GroupType"
				|| property=="QuerySource"
				|| property=="QueryField"
				|| property=="QueryFilter"
				//Button
				|| property=="DisabledIcon"
				|| property=="SearchMode"
				|| property=="AuthorityLevel"
				|| property=="AlignBase"
				)
			{
				return item.Properties[property].Value;	
			}
		
			if(property == "FilterField")
			{
				value = GOTUtil.getFilterFieldFromFormItem(item);
				if(value != null)return value; else return "";
			}
			
			if(property=="Trim")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "LeftRight";	
			}
			else if(property=="ChangeCase")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "None";
			}
			else if(property=="ShowZero")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "true";
			}
			else if(property=="AllowNegative")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "true";
			}
			else if(property=="ThousandSeperator")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "false";
			}
			else if(property=="ShowDecimals")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "2";	
			}
			else if(property=="RoundOff")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "HalfUp";
			}
			else if(property=="Seperator")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "-";
			}
			else if(property=="NumOfYear")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "4";
			}
			else if(property=="NumOfMonth")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "2";
			}
			else if(property=="NumOfDay")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "2";
			}
			else if(property=="Show1970")
			{
				return true;
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)return value;  else    return "false";
			}
			else if(property=="ShowHour" || property=="ShowMinute" || property=="ShowSecond")
			{
				return true;
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "true";
			}
			//下面两个TextTrue TextFalse 目前用不上，在画面上只是CheckBox，没有显示文字的时候
			else if(property=="TextTrue")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "是";
			}
			else if(property=="TextFalse")
			{
				value = GOTUtil.getDataTypePropertyValueFromFormItem(item, property);
				if(value!=null)	return value;	else	return "否";	
			}
		
			var formItemType = item.type;
			
			if(formItemType == "Text")
				return item.Properties[property].Value;	
		
			if(property=="Label" && formItemType=="FieldGroup")
			{
				//self
				value = item.Properties[property].Value;
				if(value!="")
					return value;
				
				//FormItem --> TableFieldGroup
				p = item.Properties["FieldGroup"];
				if(p.hasOwnProperty("refentityid"))
				{
					let refentityId = p.refentityid;
					let table = GOT.getTable(refentityId);
					let tableFieldGroup = GOT.getTableFieldGroup(table,p.refinnerid);
					value = tableFieldGroup.Properties[property].V;
					/*value = GOT.getTable(p.@refentityid).TableFieldGroups.TableFieldGroup
						.(@id==p.@refinnerid).Properties.Property
						.(Name==property).Value;*/
					if(value!="")
						return value;
					else
						return "";
				}
				
				//FormItem -->FormDataSourceField_Component
				p = item.Properties["Component"];
				if(p.hasOwnProperty("refinnerid"))
				{
					let table = GOT.getTable(p.refinnerid);
					let refinnerId = p.refinnerid;
					let tmp = GOT.getTableField(table,refinnerId);
					value = tmp.Properties[property].V;
					if(value!="")
					{
						return value;
					}
					else
					{
						let refentityId = tmp.Properties["Extends"].refentityid;
						let dataType = GOT.getDataType(refentityId);
						value = dataType.Properties[property].Value;
						if(value!="")
							return value;
						else
							return "";
					}
				}
				
				//FormItem --> Component
				p = item.Properties["Component"];
				if(p.hasOwnProperty("refentityid"))
				{
					let refentityId = p.refentityid;
					let dataType = GOT.getDataType(refentityId);
					value = dataType.Properties[property].V;
					if(value!="")
						return value;
					else
						return "";
				}
				
				return value;
				/*
				if(value=="")
					return item.@name;
				else
					return value;*/
			}
		
			if(formItemType.indexOf("Editor")==-1)
			{	
				if(property=="AllowEdit"
					|| property=="Visible")
				{
					if(formItemType == "FieldGroup")
					{
						return GOTUtil.getPropertyValueStepByStep(item, entity,property, "false", true, true); 
					}
					else
					{
						return item.Properties[property].Value;
					}
					
				}
				else if(property=="Label")
				{
					value = item.Properties[property].Value;
					if(value!="")
						return value;
					else
						return item.name;
				}
				else
					return null;//前面都已经判断完了，这种情况应该不存在
			}

		
			if(property=="AllowEditOnCreate")
			{
				var allowEdit = item.Properties["AllowEdit"].Value;
				if(allowEdit == "false")
					return "false";
				p = item.Properties["Extends"];
				if(!p.hasOwnProperty("refentityid") || !p.hasOwnProperty("refinnerid"))
					return "true";
				var pFormItem_DataSource = item.Properties["DataSource"];
				let innerId = pFormItem_DataSource.innerid;
				let formDataSource = GOT.getFormDataSource(entity,innerId);
				let formDataSourceFieldName = p.Value;
				item = GOT.getFormDataSourceField(formDataSource,formDataSourceFieldName);
				/*item = XML(getItemEntity(item).FormDataSources.FormDataSource.(@id==pFormItem_DataSource.@innerid)[0])
					.FormDataSourceFields.FormDataSourceField.(@name==p.Value)[0];*/
				allowEdit = item.Properties["AllowEdit"].Value;
				if(allowEdit == "false")
					return "false";
				let _table = GOT.getTable(p.refentityid);
				let _istmp = _table.Properties["Temporary"].V;
				if(_istmp == "true")
					return "false";
				let tableField = GOT.getTableField(_table,p.refinnerid);
				return tableField.Properties[property].V;
			}
					

			if(property=="Label")
			{
				value = GOTUtil.getPropertyValueStepByStep(item,entity, property, "", false, true);
				if(value!="" && value!=null)
					return value;
				else
				{
					return item.name;
				}
			}
			else if(property=="HelpText" 
				|| property=="DisplayLength"
				|| property=="Regular"
				|| property=="Default")
			{
				return GOTUtil.getPropertyValueStepByStep(item, entity,property, "", false, true);
			}
			else if(property=="Alignment"
				|| property=="StringSize"
				|| property=="FormLookup"
				//|| property=="ValidateLookup"
				|| property=="NumOfDecimals")
			{
				return GOTUtil.getPropertyValueStepByStep(item, entity,property, "", false, false);
			}
			else if(property=="AllowEdit")
			{
				return GOTUtil.getPropertyValueStepByStep(item, entity,property, "false", true, true);
			}
			else if(property=="Visible")
			{
				return GOTUtil.getPropertyValueStepByStep(item, entity,property, "false", true, true);
			}
			else if(property=="NotNull")
			{
				return GOTUtil.getPropertyValueStepByStep(item, entity,property, "", false, true);
			}
			return null;//FormItem应该在上面 全覆盖了 到此为null异常	
		}
		
		if(nodeName == "FormDataSource" && property=="Label")
		{
			var _tablePro = item.Properties["Table"];
			if(_tablePro.hasOwnProperty("refentityid"))
			{
				var _refentityid = _tablePro.refentityid;
				_tablePro = GOT.getTable(_refentityid);
				var _label = _tablePro.Properties["Label"].V;
				if(_label != "")
					return _label;
				return item.name;
			}
		}
		
		
		if(nodeName=="FormDataSourceField" 
			|| nodeName=="TableField"
			|| nodeName=="DataType"
			|| nodeName=="Enum")
		{
				
			if(property=="AllowEdit")
			{
				value = GOTUtil.getPropertyValueStepByStep(item, entity,property, "false", true, true);
			}
			else if(property=="Visible")
			{
				value = GOTUtil.getPropertyValueStepByStep(item, entity,property, "false", true, true);
			}
			else if(property=="NotNull")
			{
				value = GOTUtil.getPropertyValueStepByStep(item, entity,property, "", false, true);
			}
			else
			{
				value = GOTUtil.getPropertyValueStepByStep(item, entity,property, "", false, true);
			}
			
			if(value=="")
			{
				if(property=="Label")
					return item.name;
			}
			else
			{
				return value==null?"":value;
			}
		}
		
		if(nodeName=="FormDataSourceFieldGroup" && property=="Label")
		{
			var pFormDataSourceFieldGroup_FieldGroup = item.Properties["FieldGroup"];
			let refentityId = pFormDataSourceFieldGroup_FieldGroup.refentityid;
			let table = GOT.getTable(refentityId);
			let refinnerId = pFormDataSourceFieldGroup_FieldGroup.refinnerid;
			let tableFieldGroup = GOT.getTableFieldGroup(table,refinnerId);
			value = tableFieldGroup.Properties[property].V;
			/*value = GOT.getTable(pFormDataSourceFieldGroup_FieldGroup.@refentityid)
				.TableFieldGroups.TableFieldGroup.(@id==pFormDataSourceFieldGroup_FieldGroup.@refinnerid)
				.Properties.Property.(Name==property).Value;*/
			if(value=="")
				return item.name;
			else
				return value;
		}
		
		value = item.Properties.hasOwnProperty(property)?(item.Properties[property].Value || item.Properties[property].V):"";
		
		if(value=="")
		{
			if(property=="Label" && nodeName!="EnumItem")
				return item.name;
			else if(property=="DefaultOrderBy")
				return "RecIdx";
		}
		
		return value;
		
		//TODO HashMap做缓存 propertyValueHash[valueKey] = value;
	}
	

	
	
	static getTitleFormDataSource(form)
	{
		var formDesign = form.FormDesign;
		var titleDataSourcePro = formDesign.Properties["TitleDataSource"];
		var formDesignDataSourcePro = formDesign.Properties["DataSource"];
		
		var dataSource = null;
		if(titleDataSourcePro && titleDataSourcePro.hasOwnProperty("innerid"))
		{
			let innerId = titleDataSourcePro.innerid;
			dataSource = GOT.getFormDataSource(form,innerId);
			//dataSource = form.FormDataSources.FormDataSource.(@id == String(titleDataSourcePro.@innerid));
			
		}
		else if(formDesignDataSourcePro && formDesignDataSourcePro.hasOwnProperty("innerid"))
		{
			let innerId = formDesignDataSourcePro.innerid;
			dataSource = GOT.getFormDataSource(form,innerId);
			//dataSource = form.FormDataSources.FormDataSource.(@id == String(formDesignDataSourcePro.@innerid));
		}
		else if(form.FormDataSources.DataSources.length>0)
		{
			dataSource = form.FormDataSources.DataSources[0];
		}
		
		return dataSource;
		
	}
	
	static getFormDataSourceTable(dataSource)
	{
		var tablePro = dataSource.Properties["Table"];
		if(tablePro.hasOwnProperty("refentityid"))
		{
			var table = GOT.getTable(tablePro.refentityid);
			if(table == null)
				throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
			return table;
		}
		else
		{
			throw new Error("GOT错误 在DataSource上的Table属性没有继承自表");
		}
			
	}
	
	static getLabelByForm(form,firstGroup,findMenuItem = true)
	{
		var label = "";
		
		if(finedMenuItem == true)
		{
			var menuItemid = form.menuItemId;
			if(menuItemid != "")
			{
				var menuItem = GOT.getMenuItem(menuItemid);
				if(menuItem != null)
				{
					label = menuItem.Properties["Label"].V;
					if(label != "")
						return label;
				}
			}
		}
		
		var titlePro = form.Properties["Title"];
		label = titlePro.Value;
		if(label!="")
			return label;
	
		var labelPro;
		var dataSource = GOTUtil.getTitleFormDataSource(form);
		if(dataSource)
		{
			var tablePro = dataSource.Properties["Table"];
			if(tablePro.hasOwnProperty("refentityid"))
			{
				var table = GOT.getTable(tablePro.refentityid);
				if(table == null)
					throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
				labelPro = table.Properties["Label"];
				label = labelPro.V;
				if(label!="")
					return label;
			}
		}
		if(firstGroup != null)
		{
			var mainSource = firstGroup.mainSource;	
			tablePro = mainSource.xml.Properties["Table"];
			if(tablePro != null && tablePro.hasOwnProperty("refentityid"))
			{
				table = GOT.getTable(tablePro.refentityid);
				if(table != null)
				{
					label = table.Properties["Label"].V;
					if(label != "")
						return label;
				}
			}
		}
		
		if(menuItem != null)
			return menuItem.name;
		
		return form.name;
	}
	
	static getLabelByFormOrig(form)
	{
		var label = "";
		
		var titlePro = form.Properties["Title"];
		label = titlePro.Value;
		if(label!="")
			return label;
		var formDesign = form.FormDesign;
		
		var labelPro = formDesign.Properties["Label"];
		label = labelPro.Value;
		if(label!="")
			return label;
		
		var dataSource = GOTUtil.getTitleFormDataSource(form);
		if(dataSource)
		{
			var tablePro = dataSource.Properties["Table"];
			if(tablePro.hasOwnProperty("refentityid"))
			{
				var table = GOT.getTable(tablePro.refentityid);
				if(table == null)
					throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
				labelPro = table.Properties["Label"];
				label = labelPro.V;
				if(label!="")
					return label;
			}
		}
		
		return form.name;
	}
	
	static getMenuItemLabel(menuItem)
	{
		var labelPro = menuItem.Properties["Label"];
		if(labelPro.V == "")
		{
			var sourceTypePro = menuItem.Properties["SourceType"] || menuItem.Properties["Source"] ;
			var sourceType = sourceTypePro.V;
			var refObjectPro = menuItem.Properties["RefObject"] || menuItem.Properties["Source"];
			
			var id = "";
			var refObject;
			
			if(sourceType == "Form")
			{
				
				if(refObjectPro.hasOwnProperty("refentityid"))
				{
					id = refObjectPro.refentityid;
					refObject = GOT.getForm(id);
					if(refObject == null)
						throw new Error("GOT閿欒 鍦╮efObject涓婃壘涓嶅埌Form");
					return GOTUtil.getLabelByFormOrig(refObject);
				}
			}
			else if(sourceType == "Report")
			{
				if(refObjectPro.hasOwnProperty("refentityid"))
				{
					id = refObjectPro.refentityid;
					refObject = GOT.getReport(id);
					if(refObject == null)
						throw new Error("从MenuItem上找不到对应的Report");
					return GOTUtil.getFinalValue(refObject,refObject,"Label");
				}
			}
		}
		return labelPro.V;
	}
	
	
	static getMainTable(dname)
	{
		var dataType = GOT.getDataType(dname);
		if(dataType == null)
		{
			//alert("没有找到DataType" + dname);
			return null;
		}
		var dataTypeRelation = dataType.DataTypeRelation;
		if(dataTypeRelation == null) return null;
		var tablepro = dataTypeRelation.Properties["Table"];
		//var pro:XMLList = dataTypeRelation.Properties.Property.(Name == "Table");
		var obj = new Object();
		obj.mainTable = tablepro.V;
		obj.dataType = dataType;
		return obj;
	}
	
	static getAutoLookupFields(mainTable, dataTypeRelation)
	{
		var tableFields = [];
		var tableField;
		var fieldPro;
		var allTableFields = mainTable.TableFields;
		var autoLookUp = GOT.getTableFieldGroup("AutoLookup");
		for(var i in autoLookUp.FieldGroupItems)
		{
			var tableFieldGroupItem = autoLookUp.FieldGroupItems[i];
			fieldPro = tableFieldGroupItem.Properties["Field"];
			let innerId = fieldPro.innerid;
			tableField = GOT.getTableField(innerId);
			if(!tableField)
				throw new Error("GOT设置错误 在AutoLookup的GroupItem上找不到TableField");
			tableFields.push(tableField);
		}
		
		if(tableFields.length == 0)
		{
			fieldPro = mainTable.Properties["TitleField1"];
			
			if(fieldPro && fieldPro.hasOwnProperty("innerid"))
			{
				let innerId = fieldPro.innerid;
				tableField = GOT.getTableField(innerId);
				if(!tableField)
					throw new Error("GOT设置错误 在TitleField1上找不到TableField");
				tableFields.push(tableField);
			}
			fieldPro = mainTable.Properties["TitleField2"];
			if(fieldPro && fieldPro.hasOwnProperty("innerid"))
			{
				let innerId = fieldPro.innerid;
				tableField = GOT.getTableField(innerId);
				if(!tableField)
					throw new Error("GOT设置错误 在TitleField2上找不到TableField(存在innerid)");
				tableFields.push(tableField);
			}
		}
		
		
		var index;
		var indexItem;
		var indexes;
		if(tableFields.length == 0)
		{
			fieldPro = mainTable.Properties["ClusterIndex"];
			if(fieldPro.hasOwnProperty("innerid"))
			{
				let innerId = fieldPro.innerid;
				index = GOT.getTableIndex(mainTable,innerId);
				for(var i in index.IndexItems)
				{
					var indexItem = index.IndexItems[i];
					fieldPro = indexItem.Properties["Field"];
					if(fieldPro.hasOwnProperty("innerid"))
					{
						let innerId = fieldPro.innerid;
						tableField = GOT.getTableField(innerId);
						if(!tableField)
							throw new Error("GOT设置错误 在TableIndexItem上找不到TableField(存在innerid)");
						tableFields.push(tableField);
					}
				}
				
			}
		}
		
		if(tableFields.length == 0)
		{
			if(dataTypeRelation!=null)
			{
				var normalItem = GOT.getDataTypeRelationNormalItem(dataTypeRelation)
				if(normalItem!=null)
				{
					fieldPro = normalItem.Properties["Field"];
					if(fieldPro.hasOwnProperty("refinnerid"))
					{
						let refinnerId = fieldPro.refinnerid;
						tableField = GOT.getTableField(mainTable,refinnerId);
						if(!tableField)
							throw new Error("GOT设置错误 在RelationItem上找不到TableField(存在refinnerid)");
						tableFields.push(tableField);
					}
				}
				
			}
		}
		
		return tableFields;
		
	}
	
	static getComponentItemName(dataField)
	{
		if(dataField==null)
			return null;
		
		var array = dataField.split(".");
		if(array.length==3)
		{
			var s = array[2];
			return s.substr(0,1).toUpperCase() + s.substring(1);
		}
		
		return null;
	}
	
	static getDataType2(_entityId, _innerId)
	{
		// if(window.isDataSetView == true)
		// {
		// 	return null;//对于数据集统计查询页面 不需要主表下拉框一类的查询
		// }
		if(!_entityId)
		{
			throw new Error("unknown type of StringEditor");
		}

		let _entityIdArr = _entityId.split(".");
		let entityIdtmp = _entityIdArr[_entityIdArr.length-1];

		if(entityIdtmp && entityIdtmp.indexOf(".") != -1)
		{
			let entityIdtmpArr = entityIdtmp.split(".");
			let lastId = entityIdtmpArr[entityIdtmpArr.length-1];
			entityIdtmp = lastId;
		}
		var first = entityIdtmp.substr(0,2);
		if(first=="40" && _innerId!=null)
		{
			return GOTUtil.getDataTypeByFormItem(_entityId,_innerId);	
		}
		else if(first == "73" && _innerId != null)
		{
			return GOTUtil.getDataTypeByReportField(_entityId,_innerId);
		}
		else if(first=="30" && _innerId!=null)
		{
			return GOTUtil.getDataTypeByTableField(_entityId,_innerId);
		}
		else if(first=="20" && _innerId==null)
		{
			return GOTUtil.getDataTypeByDataType(_entityId);
		}
		else if(window.isDataSetView == true){
			return GOTUtil.getDataTypeByFormItem(_entityId,_innerId);
		}
		else
		{
			
			throw new Error("unknown type of StringEditor");
		}
	}
	
	static getDataTypeByReportField(entityId,innerId)
	{
		var dataType;
		var reportField = GOTUtil.getItemXML(entityId,innerId);
		
		var extendsPro = reportField.Properties["Extends"];
		if(extendsPro.hasOwnProperty("refentityid"))
		{
			dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
		}
		return dataType;
	}
	
	static getDataTypeByFormItem(entityId,innerId)
	{
		var dataType;
		var form = GOT.getForm(entityId);
		var formItem = GOT.getFormItem(form,innerId);
		//var formItem = GOT.getForm(entityId).descendants("FormItem").(@id == innerId);
		if(formItem == null)
			throw new Error("multi formitem to StringEditor");
		var extendsPro = formItem.Properties["Extends"];
		if(extendsPro && extendsPro.hasOwnProperty("refentityid"))
		{
			if(extendsPro.hasOwnProperty("refinnerid"))
			{
				var tableId = extendsPro.refentityid;
				var tableFieldId = extendsPro.refinnerid;
				dataType = GOTUtil.getDataTypeByTableField(tableId,tableFieldId);
			}
			else
			{
				dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
			}
		}
		return dataType;
	}
	
	static getDataTypeByTableField(tableId,tableFieldId)
	{
		var table = GOT.getTable(tableId);
		var dataType;
		if(table)
		{
			var tableField = GOT.getTableField(table,tableFieldId);
			var extendsPro = tableField.Properties["Extends"];
			if(extendsPro.hasOwnProperty("refentityid"))
				dataType = GOTUtil.getDataTypeByDataType(extendsPro.refentityid);
		}
		return dataType;
	}
	
	static getDataTypeByDataType(entityId)
	{
		var dataType = GOT.getDataType(entityId);
		return dataType;
	}
	
	//TODO Inner节点目前只支持TableField 发现错误应该再加 比如Report Flex版由于e4x都支持
	static getItemXML(entityId,innerId)
	{
		var entity = GOTUtil.getEntityXML(entityId);
		if(innerId)
		{
			return GOTUtil.getInnerXML(entity, innerId);
		}
			
		return entity;
	}
	
	static getEntityType(entityId)
	{
		var type;

		if(!entityId)
		{
			return null;
		}

		let _entityIdArr = entityId.split(".");
		entityId = _entityIdArr[_entityIdArr.length-1];
		var first = parseInt(entityId.substr(0,2));
		if(first==10)
			type = "Enum"; 
		else if(first==20)
			type = "DataType";
		else if(first==30)
			type = "Table";
		else if(first==40)
			type = "Form";
		else if(first==50)
			type = "MenuItem";
		else if(first==60)
			type = "Menu";
		else if(first==71)
			type = "Map";
		else if(first==72)
			type = "Query";
		else if(first == 73)
			type = "Report";
		else
			type = null;
		
		return type;
	}
	
	
	static getEntityXML(_id)
	{
		if(_id == null)
			return null;
		
		var type = GOTUtil.getEntityType(_id);
		
		switch(type)
		{
			case "Enum":
				return GOT.getEnum(_id);
			case "DataType":
				return GOT.getDataType(_id);
			case "Table":
				return GOT.getTable(_id);
			case "MenuItem":
				return GOT.getMenuItem(_id);
			case "Menu":
				return GOT.getMenu(_id);
			case "Form":
				return GOT.getForm(_id);
			case "Query":
				return GOT.getQuery(_id);
			case "Report":
				return GOT.getReport(_id);
			default :
				throw new Error("非法的Entity Type");
		}
	}
	
	/*private static var innerCache:Object = {};
	public static function clearInnerCache(entityid:String = null):void
	{
		if(entityid == null)
		{
			innerCache = {};
		}
		else
		{
			var temp:Vector.<String> = new Vector.<String>();
			for (var key:String in innerCache)
			{
				if(key.split(".")[0] == entityid)
				{
					temp.push(key);
				}
			}
			
			for each(key in temp)
			{
				innerCache[key] = null;
				delete innerCache[key];
			}
		}
	}*/
	
	static getInnerXML(entity,innerId)
	{
		let id = entity.id;
		if(!id)
			return;
		let _entityIdArr = id.split(".");
		id = _entityIdArr[_entityIdArr.length-1];
		if(id.indexOf("3") == 0)
		{
			return GOT.getTableField(entity,innerId)
		}
	}

	/*public static function getInnerXML(entity, _innerId)
	{
		
		let qname = (entity.hasOwnProperty("FormDesign")?"Form":"");
		if(qname == "Form")
		{
			return GOT.getFormItem(entity,_innerId);
		}
		else
		{
			list = entity.descendants().(hasOwnProperty("@id")&&@id==_innerId);
		}
		
	}*/
	
	static getFormItemInnerXML(entity,_innerId)
	{
		return GOT.getFormItem(entity,_innerId);
	}
	
	static parseUserForm2Form(formXML,root)
	{
		var parent = GOTUtil.parseUserForm2FormItem(formXML,root);
		var childs = root.children;
		for(let i = 0;i<childs.length;i++)
		{
			let item = childs[i];
			parent.appendChild(GOTUtil.parseUserForm2Form(formXML,item));
		}
		return parent;
	}

	//for Form JSON
	static formItemCache2 = {};
	static getFormItemInnerXMLByCache2(entity, _innerId)
	{
		if(!GOTUtil.formItemCache2[entity.id + "_" + _innerId])
		{	
			var list = GOTUtil.elementsFormHasId(entity);
			for(let i = 0;i<list.length;i++)
			{
				let node = list[i];
				GOTUtil.formItemCache2[entity.id + "_" + node.id] = node;
				GOTUtil.getFormItemInnerXMLByCache2(node,_innerId);
			}
		}
		
		return GOTUtil.formItemCache2[entity.id + "_" + _innerId];
	}

	//for Form XML
	static formItemCache = {};
	static getFormItemInnerXMLByCache(entity, _innerId)
	{
		if(!GOTUtil.formItemCache[entity.id + "_" + _innerId])
		{	
			var list = entity.getElementsByTagName("FormItem");
			for(let i = 0;i<list.length;i++)
			{
				let node = list[i];
				GOTUtil.formItemCache[entity.id + "_" + node.id] = node;
			}
		}
		
		return GOTUtil.formItemCache[entity.id + "_" + _innerId];
	}
	
	static parseUserForm2FormItem(formXML,item)
	{
		var innerId = item.id;
		let formItem;
		if(!innerId || innerId == "FormDesign")
		{
			formItem = formXML.children[2].cloneNode(true);
		}
		else
		{
			formItem = GOTUtil.getFormItemInnerXMLByCache(formXML,innerId).cloneNode(true);	
		}

		let userProperties = {};
		var atts = item.attributes;
		for(var k=0; k<atts.length; k++)
		{
			var att = atts[k];
			if(att.nodeName != "id")
				userProperties[att.nodeName] = att.nodeValue;
		}
		
		var _parentWindow = window.parent.window;
		if(!_parentWindow.userProperties)
			_parentWindow.userProperties = {};
		if(!_parentWindow.userProperties[window.menuItemId+"."+window.formId])
			_parentWindow.userProperties[window.menuItemId+"."+window.formId] = {};
		var allUserProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
		if(!allUserProperties.hasOwnProperty(innerId))
			allUserProperties[innerId] = {};
		Object.assign(allUserProperties[innerId],userProperties);

		var childs = formItem.childNodes; 
		for(var i = childs.length - 1; i >= 0; i--)
		{
		  let child = childs[i];
		  if(child.nodeName != "Properties")
		  	formItem.removeChild(childs[i]);
		}
		return formItem;
	}

	static descendantsFormHasIdItem(item,result)
	{
		let qname = item.qname;
		if(qname == "FormDataSources")
		{
			GOTUtil.descendantsFormDataSourcesHasId(item,result);
		}
		else if(qname == "FormDataSource")
		{
			GOTUtil.descendantsFormDataSourceHasId(item,result);
		}
		else if(qname == "FormDataSourceFieldGroup" || qname == "FormDataSourceField")
		{
			result.push(item);
		}
		else if(qname == "FormItem" || qname == "FormDesign")
		{
			GOTUtil.descendantsFormDesignHasId(item,result);
		}
	}

	static descendantsFormHasId(form,result)
	{
		let formDataSources = form.FormDataSources;
		result.push(formDataSources);
		GOTUtil.descendantsFormDataSourcesHasId(formDataSources,result);
		let formDesign = form.FormDesign;
		result.push(formDesign);
		GOTUtil.descendantsFormDesignHasId(formDesign,result);
	}

	static elementsFormHasId(item)
	{
		let qname = item.qname;
		if(qname == "Form")
		{
			return [item.FormDataSources,item.FormDesign];
		}
		if(qname == "FormDataSources")
		{
			return item.DataSources;
		}
		else if(qname == "FormDataSource")
		{
			return item.FormDataSourceFieldGroups.concat(item.FormDataSourceFields);
		}
		else if(qname == "FormDataSourceFieldGroup" || qname == "FormDataSourceField")
		{
			return [];
		}
		else if(qname == "FormItem" || qname == "FormDesign")
		{
			return item.FormItem;
		}
		return [];
	}

	static descendantsFormDesignHasId(item,result)
	{
		let formItems = item.FormItem;
		for(let i = 0;i<formItems.length;i++)
		{
			let formItem = formItems[i];
			result.push(formItem);
			GOTUtil.descendantsFormDesignHasId(formItem,result);
		}
	}

	static descendantsFormDataSourcesHasId(item,result)
	{
		let dataSources = item.DataSources;
		for(let i = 0;i<dataSources.length;i++)
		{
			let dataSource = dataSources[i];
			result.push(dataSource);
			GOTUtil.descendantsFormDataSourceHasId(dataSource,result);
		}
	}

	static descendantsFormDataSourceHasId(item,result)
	{
		let formDataSourceFieldGroups = item.formDataSourceFieldGroups;
		for(let i = 0;i<formDataSourceFieldGroups.length;i++)
		{
			let formDataSourceFieldGroup = formDataSourceFieldGroups[i];
			GOTUtil.descendantsFormDataSourceFieldGroupHasId(formDataSourceFieldGroup);
		}
		let formDataSourceFields = item.FormDataSourceFields;
		for(let i = 0;i<formDataSourceFields.length;i++)
		{
			let formDataSourceField = formDataSourceFields[i];
			GOTUtil.descendantsFormDataSourceFieldHasId(formDataSourceField,result);
		}
	}

	static descendantsFormDataSourceFieldHasId(item,result)
	{
		result.push(item);
	}

	static descendantsFormDataSourceFieldGroupHasId(item,result)
	{
		result.push(item);
	}
	
	
	/////////////////////////////////////////////////////////////////////////////////
	static getArrayItemByName(dataType,itemName)
	{
		return GOT.getDataTypeArrayItem(dataType,itemName);
	}
	
	static getDataSourceByDataSource(extendsPro)
	{
		if(!extendsPro.hasOwnProperty("refentityid"))
			return [];
		var tableId = extendsPro.refentityid;
		var tableFieldId = extendsPro.refinnerid;
		var _table = GOT.getTable(tableId);
		var tableField = GOT.getTableField(_table,tableFieldId);
		
		if(tableField.type == "Component")
		{
			var textendsPro = tableField.Properties["Extends"];
			if(!textendsPro.hasOwnProperty("refentityid"))
				throw new Error("GOT错误:Component类型的TableField没有正确关联到一个对应的DataType");
			var cdataTypeId = textendsPro.refentityid;
			var cdataType = GOT.getDataType(cdataTypeId);
			var value = extendsPro.V;
			var arrayItemName = value.split(".")[1];
			var arrayItem = GOT.getDataTypeArrayItem(cdataType,arrayItemName);
			var refDataTypePro = arrayItem.Properties["RefDataType"];
			if(!refDataTypePro.hasOwnProperty("refentityid"))
				throw new Error("GOT错误:" + cdataType.name + "." + arrayItemName + "没有关联到DataType");
			
			return GOTUtil.getDataSourceByDataType(refDataTypePro);
		}
		else
		{
			return GOTUtil.getDataSourceByTableField(tableField);
		}
	}
	
	static getDataSourceByTableField(tableField)
	{
		var sourcePro = tableField.Properties["Source"];
		
		var extendsPro = tableField.Properties["Extends"];
		
		if(!extendsPro.hasOwnProperty("refentityid"))
			return GOTUtil.getDataSourceByRegular(tableField);
		
		if(sourcePro.V == "Enum")
		{				
			return GOTUtil.getDataSourceByEnum(extendsPro); 	
		}
		else
		{
			return GOTUtil.getDataSourceByDataType(extendsPro);
		}
	}
	
	static getDataSourceByReportField(reportField)
	{
		var sourcePro = reportField.Properties["Source"];
		var extendsPro = reportField.Properties["Extends"];
		//tableField.Properties.Property.(Name == "Extends");
		
		if(!extendsPro.hasOwnProperty("refentityid"))
			return GOTUtil.getDataSourceByRegular(reportField);
		
		if(sourcePro.V == "Enum")
		{				
			return GOTUtil.getDataSourceByEnum(extendsPro); 	
		}
		else
		{
			return GOTUtil.getDataSourceByDataType(extendsPro);
		}
	}
	
	static getDataSourceByEnum(extendsPro)
	{
		if(!extendsPro.hasOwnProperty("refentityid"))
			return [];
		var enumId = extendsPro.refentityid;
		
		var entityEnum = GOT.getEnum(enumId);
		
		var collection = [];
		
		var label;
		
		var value;
		
		for(var i in entityEnum.EnumItems)
		{
			let item = entityEnum.EnumItems[i];
			label = item.Properties["Label"].V;
			value = item.Properties["Value"].V;
			
			collection.push(
				{label:label,value:value}
			);
		}
		
		return collection ;
	}
	
	static getDataSourceByDataType(extendsPro)
	{
		if(!extendsPro.hasOwnProperty("refentityid"))
			return [];
		
		var dataType = GOT.getDataType(extendsPro.refentityid);
		var extendsPro = dataType.Properties["Extends"]; 
		
		var sourcePro;
		while(extendsPro.hasOwnProperty("refentityid"))
		{
			sourcePro = dataType.Properties["Source"];
			if(sourcePro == undefined)
				throw new Error("从EnumEditor到DataType的继承链上存在非Enum类型的DataType");
			
			if(sourcePro.V == "Enum")
			{
				return GOTUtil.getDataSourceByEnum(extendsPro);
			}
			dataType = GOT.getDataType(extendsPro.refentityid);
			extendsPro = dataType.Properties["Extends"];
		}
		
		return GOTUtil.getDataSourceByRegular(dataType);
	}
	
	static getDataSourceByRegular(node)
	{
		var regularPro = node.Properties["Regular"];
		
		if(regularPro == null)
			return null;
		
		var regular = regularPro.hasOwnProperty("Value")?regularPro.Value:regularPro.V;
		
		var collection = [];
		
		var value;
		
		var label;
		
		if(regular != "")
		{
			var array = regular.split("|");
			for(var i in array)
			{
				let item = array[i];
				if(item.indexOf(":") > -1)
				{
					value = item.split(":")[0];
					label = item.split(":")[1];
				}
				else
				{
					value = item;
					label = item;
				}
				
				collection.push(
					{label:label,value:value}
				);
			}
			
		}
		
		return collection;
	}
	
	static getQueryTableByName(query,name)
	{
		var queryTables = query.QueryTable.QueryJoins.Items;
		for(let i = 0;i<queryTables.length;i++)
		{
			let queryTable = queryTables[i];
			if(queryTable.name == name)
				return queryTable;
		}
		return null;
	}

	static getQueryRelationItemByProperty(queryRelation,propertyName)
	{
		var items = queryRelation.Items;
		var result = [];
		for(let i = 0;i<items.length;i++)
		{
			let item = items[i];
			if(item.hasOwnProperty(propertyName))
				result.push(item);
		}
		return result;
	}

	static getQueryRelationItemByPropertyQuery(query,propertyName)
	{
		var result = [];
		var queryTableItems = query.QueryTable.QueryJoins.Items;
		for(let i = 0;i<queryTableItems.length;i++)
		{
			let queryTable = queryTableItems[i];
			let queryRelation = queryTable.QueryRelation;
			var items = queryRelation.Items;
			
			for(let k = 0;k<items.length;k++)
			{
				let item = items[k];
				if(item.hasOwnProperty(propertyName))
					result.push({parent:queryRelation,item:item});
			}
		}
		return result;
	}

	static getQueryWhereItemByPropertyValue(query,propertyName,propertyValue)
	{
		var result = [];
		var queryWhereItems = query.hasOwnProperty("QueryWhere")?query.QueryWhere.Items:query.QueryTable.QueryWhere.Items;
		for(let i = 0;i<queryWhereItems.length;i++)
		{
			let queryWhereItem = queryWhereItems[i];
			let _value = GOTUtil.getPropertyValue(queryWhereItem,propertyName);
			if(_value == propertyValue)
			{
				result.push(queryWhereItem);
			}
		}
		return result;
	}

	static getQueryTableByAlias(alias,query)
	{
		var queryTable = GOTUtil.getQueryTableByAlias2(alias, query.QueryTable);
		if(queryTable==null)
			throw new Error("queryTable can't find");
		
		return queryTable;
	}

	static getQueryTableByAlias2(alias, queryTable)
	{
		if(alias==null || queryTable==null)
			return null;
		
		var _alias = queryTable.Properties.Alias.V;
		if(_alias==alias)
			return queryTable;
		
		if(queryTable.QueryJoins==null)
			return null;
		
		var list = queryTable.QueryJoins.Items;
		if(list==null || list.length==0)
			return null;
		
		for(var i=0;i<list.length;i++)
		{
			var qt = list[i];
			var result = GOTUtil.getQueryTableByAlias2(alias, qt);
			if(result!=null)
				return result;
		}
		
		return null;
	}

	static getTitleFormDataSource(form)
	{
		var formDesign = form.FormDesign;
		var titleDataSourcePro = formDesign.Properties.TitleDataSource;
		var formDesignDataSourcePro = formDesign.Properties.DataSource;
		
		var dataSource = null;
		if(titleDataSourcePro && titleDataSourcePro.hasOwnProperty("innerid"))
		{
			dataSource = GOT.getFormDataSource(form,titleDataSourcePro.innerid);
			
		}
		else if(formDesignDataSourcePro&&formDesignDataSourcePro.hasOwnProperty("innerid"))
		{
			dataSource = GOT.getFormDataSource(form,formDesignDataSourcePro.innerid);
		}
		else
		{
			dataSource = form.FormDataSources.DataSources.length>0?form.FormDataSources.DataSources[0]:null;
		}
		
		if(dataSource)
		{
			return dataSource;
		}
		
		return null;
	}

	static getLabelByForm(form,firstGroup,menuItemid)
	{
		var label = "";
		if(!menuItemid)
			menuItemid = window.menuItemId;
		if(menuItemid)
		{
			var menuItem = GOT.getMenuItem(menuItemid);
			if(menuItem)
			{
				label = menuItem.Properties.Label.V;
				if(label != "")
					return label;
			}
		}
		var titlePro = form.Properties.Title;
		label = titlePro.Value;
		if(label!="")
			return label;
		
		var labelPro;
		var dataSource = GOTUtil.getTitleFormDataSource(form);
		if(dataSource)
		{
			var tablePro = dataSource.Properties.Table;
			if(tablePro.hasOwnProperty("refentityid"))
			{
				var table = GOT.getTable(tablePro.refentityid);
				if(table == null)
					throw new Error("GOT错误 在DataSource的Table上找不到Table Entity");
				labelPro = table.Properties.Label;
				label = labelPro.V;
				if(label!="")
					return label;
			}
		}
		if(firstGroup)
		{
			var mainSource = firstGroup.mainSource;	
			tablePro = mainSource.xml.Properties.Table;
			if(tablePro && tablePro.hasOwnProperty("refentityid"))
			{
				table = GOT.getTable(tablePro.refentityid);
				if(table != null)
				{
					label = table.Properties.Label.V;
					if(label != "")
						return label;
				}
			}
		}
		
		if(menuItem)
			return menuItem.name;
		
		return form.name;
	}
	static getPropertyValue(xml,property)
	{
		if(xml.hasOwnProperty("Properties"))
		{
			var properties = xml.Properties;
			if(properties.hasOwnProperty(property))
			{
				var propertyEntity = properties[property];
				let result = propertyEntity.V || propertyEntity.Value;
				if(!result)result = "";
				return result;
			}
		}
		return null;
	}

	static getProperty(xml,property)
	{
		if(xml.hasOwnProperty("Properties"))
		{
			var properties = xml.Properties;
			if(properties.hasOwnProperty(property))
			{
				return properties[property];
			}
		}
		return null;
	}

	static getShortCut(table)
	{
		if(table == null)
			return null;
		var result = null;
		var shortcutPro = table.Properties.ShortCutField;
		if(shortcutPro && shortcutPro.hasOwnProperty("innerid"))
		{
			var innerid = shortcutPro.innerid;
			result =  GOT.getTableField(table,innerid);
			return result;
		}
		
		return null;
	}

	static getNotComponentFormDataSourceFields(dataSource)
	{
		let result = [];
		for(let i = 0;i<dataSource.FormDataSourceFields.length;i++)
		{
			let dataSourceField = dataSource.FormDataSourceFields[i];
			if(dataSourceField.type != "Component")
				result.push(dataSourceField);
		}
		return result;
	}
	

}


// WEBPACK FOOTER //
// ./src/utils/GOTUtil.js